import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchOrders = async ({ page = 1, limit = 10, search = null, status = null }) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    if (search) {
      query += `&search=${search}`;
    }

    if (status) {
      query += `&status=${status}`;
    }

    const response = await authClient.get(`/orders${query}`);
    return {
      data: {
        orders: response.data.data.orders,
        page: response.data.data.pagination.currentPage,
        totalPages: response.data.data.pagination.totalPages,
        totalItems: response.data.data.pagination.totalItems,
      },
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju narudžbina.'
    );
    return { data: null, error: message };
  }
};

export const fetchOrderEarnings = async ({ year }) => {
  try {
    const response = await authClient.get(`/orders/earnings?year=${year}`);
    return {
      data: response.data.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju zarade.'
    );
    return { data: null, error: message };
  }
};

export const fetchOrder = async ({ id }) => {
  try {
    const response = await authClient.get(`/orders/${id}`);
    return {
      data: response.data.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju porudžbine.'
    );
    return { data: null, error: message };
  }
};

export const fetchUserVipStatus = async (userId) => {
  try {
    const response = await authClient.get(`/users/${userId}/vip-status`);
    return {
      data: response.data.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju VIP statusa korisnika.'
    );
    return { data: null, error: message };
  }
};

export const fetchProducts = async ({
  page = 1,
  limit = 10,
  search = null,
  isDeleted = undefined,
  isSubscriptionOnlyProduct = undefined,
  hasSubscriptionPackage = undefined,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;

    if (search) {
      query += `&searchTerm=${search}`;
    }

    if (isDeleted !== undefined) {
      query += `&isDeleted=${isDeleted}`;
    }

    if (isSubscriptionOnlyProduct !== undefined) {
      query += `&isSubscriptionOnlyProduct=${isSubscriptionOnlyProduct}`;
    }

    if (hasSubscriptionPackage !== undefined) {
      query += `&hasSubscriptionPackage=${hasSubscriptionPackage}`;
    }

    const response = await authClient.get(`/products${query}`);
    console.log('Products response:', response);
    return {
      data: {
        products: response.data.data.products,
        page: response.data.data.pagination.currentPage,
        totalPages: response.data.data.pagination.totalPages,
        totalItems: response.data.data.pagination.totalItems,
      },
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju proizvoda.'
    );
    return { data: null, error: message };
  }
};

export const fetchProductFilters = async () => {
  try {
    const response = await authClient.get('/products/filters');
    return { data: response.data.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju filtera za proizvode.'
    );
    return { data: null, error: message };
  }
};

export const fetchProductById = async (id) => {
  try {
    const response = await authClient.get(`/products/${id}`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const createProduct = async (payload) => {
  try {
    const response = await authClient.post('/products', payload);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri kreiranju proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProduct = async (id, payload) => {
  try {
    const response = await authClient.put(`/products/${id}`, payload);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izmeni proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const fetchProductCommissionChain = async (id) => {
  try {
    const response = await authClient.get(`/products/${id}/commission-chain`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri učitavanju provizije mentorskog lanca.'
    );
    return { data: null, success: false, message };
  }
};

export const saveProductCommissionChain = async (id, payload) => {
  try {
    const response = await authClient.put(`/products/${id}/commission-chain`, payload);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri čuvanju provizije mentorskog lanca.'
    );
    return { data: null, success: false, message };
  }
};

export const deleteProductCommissionChain = async (id) => {
  try {
    const response = await authClient.delete(`/products/${id}/commission-chain`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri uklanjanju provizije mentorskog lanca.'
    );
    return { data: null, success: false, message };
  }
};

export const fetchProductAgentCommission = async (id) => {
  try {
    const response = await authClient.get(`/products/${id}/commission-agent`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri učitavanju provizije za agente.'
    );
    return { data: null, success: false, message };
  }
};

export const saveProductAgentCommission = async (id, payload) => {
  try {
    const response = await authClient.put(`/products/${id}/commission-agent`, payload);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri čuvanju provizije za agente.'
    );
    return { data: null, success: false, message };
  }
};

export const deleteProductAgentCommission = async (id) => {
  try {
    const response = await authClient.delete(`/products/${id}/commission-agent`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri uklanjanju provizije za agente.'
    );
    return { data: null, success: false, message };
  }
};

export const fetchProductCashbackOverride = async (id) => {
  try {
    const response = await authClient.get(`/products/${id}/cashback-override`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri učitavanju cashback podešavanja proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const saveProductCashbackOverride = async (id, payload) => {
  try {
    const response = await authClient.put(`/products/${id}/cashback-override`, payload);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri čuvanju cashback podešavanja proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const deleteProductCashbackOverride = async (id) => {
  try {
    const response = await authClient.delete(`/products/${id}/cashback-override`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri uklanjanju cashback podešavanja proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const getProductSubscriptionPackage = async (id) => {
  try {
    const response = await authClient.get(`/products/${id}/subscription-package`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri učitavanju paketa za pretplatu.'
    );
    return { data: null, success: false, message };
  }
};

export const upsertProductSubscriptionPackage = async (id, payload) => {
  try {
    const response = await authClient.put(`/products/${id}/subscription-package`, payload);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri čuvanju paketa za pretplatu.'
    );
    return { data: null, success: false, message };
  }
};

export const deleteProductSubscriptionPackage = async (id) => {
  try {
    const response = await authClient.delete(`/products/${id}/subscription-package`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri uklanjanju paketa za pretplatu.'
    );
    return { data: null, success: false, message };
  }
};

export const hideProduct = async (id) => {
  try {
    const response = await authClient.delete(`/products/${id}`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri sakrivanju proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const restoreProduct = async (id) => {
  try {
    const response = await authClient.patch(`/products/${id}/restore`);
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri vraćanju proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductStockStatus = async (id, stockStatus) => {
  try {
    const response = await authClient.patch(
      `/products/${id}/update-stock-status`,
      { stock_status: stockStatus }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju statusa zaliha.'
    );
    return { data: null, success: false, message };
  }
};

export const updateOrderStatus = async (orderId, status) => {
  try {
    const response = await authClient.put(`/orders/${orderId}`, { status });

    return {
      data: {
        order: response.data.order,
      },
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri ažuriranju statusa porudžbine.'
    );
    return { data: null, error: message };
  }
};

export const editOrderContents = async (orderId, payload) => {
  try {
    const response = await authClient.put(`/orders/${orderId}/contents`, payload);
    return { data: response.data.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izmeni porudžbine.'
    );
    return { data: null, error: message };
  }
};

// Admin-created COD/in-person order, optionally on behalf of an existing user
// (payload.userId). Priced and completed by the backend exactly as if that user
// had checked out in the app.
// Backend pricing breakdown for the create-order modal, priced as payload.userId
// (or a guest). Same shape as the app's cart preview; checkout rule violations come
// back in data.errorMessages rather than as an error.
export const previewAdminOrder = async (payload) => {
  try {
    const response = await authClient.post('/orders/admin/preview', payload);
    return { data: response.data.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izračunavanju pregleda porudžbine.'
    );
    return { data: null, error: message };
  }
};

export const createOrder = async (orderData) => {
  try {
    const response = await authClient.post('/orders/admin', orderData);
    return { data: response.data.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri kreiranju porudžbine.'
    );
    return { data: null, error: message };
  }
};

export const updateIsProductHidden = async (productId, isProductHidden) => {
  try {
    const response = await authClient.patch(
        `/products/${productId}/update-is-product-hidden`,
        { isProductHidden }
    );
    return { data: response.data, success: true };
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri ažuriranju prikaza proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductIsConfigurationProduct = async (id, isConfigurationProduct) => {
  try {
    const response = await authClient.patch(
        `/products/${id}/update-configuration-product`,
        { isConfigurationProduct }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri ažuriranju konfiguracionog proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductIsMix4IndividuallySellable = async (id, isMix4IndividuallySellable) => {
  try {
    const response = await authClient.patch(
        `/products/${id}/update-mix4-individually-sellable`,
        { isMix4IndividuallySellable }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
        error,
        'Došlo je do greške pri ažuriranju pojedinačne prodaje Mix4 proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const deleteOrder = async (orderId) => {
  try {
    const response = await authClient.delete(`/orders/${orderId}`);
    return { data: response.data, success: true, message: null };
  } catch (error) {
    const message = extractErrorMessage(error, 'Došlo je do greške pri brisanju narudžbine.');
    return { data: null, success: false, message };
  }
};

export const updateProductHasQuantityDiscount = async (
  id,
  hasQuantityDiscount
) => {
  try {
    const response = await authClient.patch(
      `/products/${id}/update-has-quantity-discount`,
      { hasQuantityDiscount }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju količinskog popusta.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductIsExternalProduct = async (
  id,
  isExternalProduct
) => {
  try {
    const response = await authClient.patch(
      `/products/${id}/update-external-product`,
      { isExternalProduct }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju eksternog proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductIsFrozenProduct = async (
  id,
  isFrozenProduct
) => {
  try {
    const response = await authClient.patch(
      `/products/${id}/update-frozen-product`,
      { isFrozenProduct }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju zamrznutog proizvoda.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductSkipReferredDiscount = async (
  id,
  skipReferredDiscount
) => {
  try {
    const response = await authClient.patch(
      `/products/${id}/update-skip-referred-discount`,
      { skipReferredDiscount }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju opcije isključenja 5% popusta.'
    );
    return { data: null, success: false, message };
  }
};

export const fetchCurrentCheckoutUpsellProduct = async () => {
  try {
    const response = await authClient.get('/products/checkout-upsell');
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri učitavanju trenutne ponude za dodatnu kupovinu.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductCheckoutUpsell = async (
  id,
  isCheckoutUpsell,
  checkoutUpsellDiscountPercent
) => {
  try {
    const response = await authClient.patch(
      `/products/${id}/update-checkout-upsell`,
      { isCheckoutUpsell, checkoutUpsellDiscountPercent }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju ponude za dodatnu kupovinu.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductIsSubscriptionOnly = async (
  id,
  isSubscriptionOnlyProduct
) => {
  try {
    const response = await authClient.patch(
      `/products/${id}/update-subscription-only`,
      { isSubscriptionOnlyProduct }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju pretplatničkog paketa.'
    );
    return { data: null, success: false, message };
  }
};

export const updateProductIsEligibleToBuyWithPoints = async (
  id,
  isEligibleToBuyWithPoints
) => {
  try {
    const response = await authClient.patch(
      `/products/${id}/update-is-eligible-to-buy-with-points`,
      { isEligibleToBuyWithPoints }
    );
    return response.data;
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri ažuriranju mogućnosti kupovine poenima.'
    );
    return { data: null, success: false, message };
  }
};